"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M14.305 19.18l3.195 4.26L19.42 22l-3.4-4.534.022-.023-1.212-1.616-.023.023-8-10.668.032-.01-1.25-1.668-.03.014L2.92 0 1 1.44l2.606 3.474a6 6 0 00.151 8.329L12 21.485l2.305-2.305zm-1.212-1.616L12 18.657l-6.828-6.829a4 4 0 01-.337-5.275l8.258 11.01zM20.243 13.243l-2.486 2.486-1.213-1.616 2.284-2.285a4 4 0 00-5.493-5.81L12 7.212l-1.335-1.196a4 4 0 00-.458-.354l-1.994-2.66A5.978 5.978 0 0112 4.529a6 6 0 018.243 8.715z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;